"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = exports.Caret = exports.Option = exports.Select = exports.SelectInputContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SelectInputContainer = _styledComponents["default"].div.withConfig({
  displayName: "StyledElements__SelectInputContainer",
  componentId: "sc-1yvi6c4-0"
})(["width:100%;padding-top:14px;position:relative;margin-bottom:20px;border-bottom:solid 2px #9ba1ac;margin:5px;max-height:45px;"]);

exports.SelectInputContainer = SelectInputContainer;

var Select = _styledComponents["default"].select.withConfig({
  displayName: "StyledElements__Select",
  componentId: "sc-1yvi6c4-1"
})(["border:0;-moz-appearance:none;-webkit-appearance:none;display:block;width:100%;padding:0;margin:0;font-size:15px;line-height:30px;background-color:transparent;position:relative;color:", ";padding-top:15px;padding-bottom:3px;cursor:pointer;&:focus{outline:0;}&:focus ~ .caret{transform:rotate(180deg);transition:transform 0.5s ease-in-out;}&:focus ~ .label{opacity:0.6;color:#9ba1ac;font-size:14px;transform-origin:0 0;transform:translateY(-24px) scale(0.8);line-height:16px;}&:focus-within::after{transform:translateX(0%);width:100%;left:0;background-color:#2f4ff1;transition:width 0.9s ease-in-out;}&::after{display:block;width:0%;position:absolute;bottom:-2;left:100%;transform:translateX(-100%);right:0;background-color:#9ba1ac;height:3px;content:'';transition:width 0.9s ease-in-out;}"], function (_ref) {
  var hasInput = _ref.hasInput;
  return hasInput ? '#9ba1ac' : 'transparent';
});

exports.Select = Select;

var Option = _styledComponents["default"].option.withConfig({
  displayName: "StyledElements__Option",
  componentId: "sc-1yvi6c4-2"
})(["color:black;"]);

exports.Option = Option;

var Caret = _styledComponents["default"].div.withConfig({
  displayName: "StyledElements__Caret",
  componentId: "sc-1yvi6c4-3"
})(["background:url('/images/select-arrow.svg') no-repeat;display:block;position:absolute;right:0%;top:", ";width:", ";height:", ";transform:rotate(360deg);transition:transform 0.5s ease-in-out;pointer-events:none;"], function (_ref2) {
  var isHovered = _ref2.isHovered;
  return isHovered ? '60%' : '70%';
}, function (_ref3) {
  var isHovered = _ref3.isHovered;
  return isHovered ? '24px' : '20px';
}, function (_ref4) {
  var isHovered = _ref4.isHovered;
  return isHovered ? '16px' : '12px';
});

exports.Caret = Caret;

var Label = _styledComponents["default"].label.withConfig({
  displayName: "StyledElements__Label",
  componentId: "sc-1yvi6c4-4"
})(["color:#9ba1ac;font-size:15px;position:absolute;top:39px;left:0;line-height:14px;transition:all 0.2s ease-in-out;", ""], function (_ref5) {
  var hasInput = _ref5.hasInput;
  return hasInput && "opacity: 0.6;\n    color: #9ba1ac;\n    font-size: 14px;\n    transform-origin: 0 0;\n    transform: translateY(-24px) scale(0.8);\n    line-height: 16px;";
});

exports.Label = Label;